import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'commentsOriginalStyling',
    label: 'Comments Original Styling',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
